// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDWb6mD_ltr6-TyMGNmAmsK68BSd3YOnLU",
    authDomain: "w3-mail.firebaseapp.com",
    projectId: "w3-mail",
    storageBucket: "w3-mail.appspot.com",
    messagingSenderId: "612719749097",
    appId: "1:612719749097:web:afb3b211174b89a41e4d78"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth();
export const db = getFirestore();